import { render } from "./ValidationHistoryPage.vue?vue&type=template&id=1db0edf0"
import script from "./ValidationHistoryPage.vue?vue&type=script&lang=js"
export * from "./ValidationHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__